import { EventFeeFunctions } from '@/enums/eventFeeFunctions.enum';
import { EventFunctions } from '@/enums/eventFunctions.enum';
import store from '@/store/store';
import { getTimePeriod, getToday } from '@/utils/time';

/**
 * Pobiera wydarzenia kalendarza
 *
 * @export
 * @param {*} to
 * @param {number} id
 * @param {string} entityType
 * @returns {Promise<any[]>}
 */
export function dispatchEvents(to: any, id: number, entityType: string): Promise<any[]> {
  const timePeriod = getTimePeriod(to.params.view, to.query.year, to.query.month, to.query.day);

  return Promise.all([
    store.dispatch('events/list', {
      id,
      eventType: (EventFunctions as any)[entityType],
      start: timePeriod.start,
      end: timePeriod.end
    }),
    store.dispatch('fee/events/list', {
      id,
      eventType: (EventFeeFunctions as any)[entityType],
      start: timePeriod.start,
      end: timePeriod.end
    })
  ]);
}

/**
 * Ustawia query widoku kalendarza
 *
 * @export
 * @param {*} to
 * @param {*} next
 * @returns
 */
export function fixCalendarRoute(to: any, next: any) {
  const today = getToday();
  const nextRoute = {
    name: to.name,
    params: to.params,
    query: { ...to.query, year: today.year, month: today.month, day: today.day }
  };
  next(nextRoute);
}

export function beforeCalendarRoute(to: any, id: number, entityType: string, next: any, ...promises: any[]) {
  if (to.query.year && to.query.month && to.query.day) {
    Promise.all([dispatchEvents(to, id, entityType), ...promises])
      .then(() => next())
      .catch(() => store.dispatch('notifyError', { title: 'messages.event.error' }));
  } else {
    fixCalendarRoute(to, next);
  }
}
